import Vue from 'vue'
import VueRouter from 'vue-router'
import Login from '../views/Login.vue'
import Qs from 'qs'

Vue.use(VueRouter)
const routes = [
  {
    path: '/',
    name: 'Login',
    component: Login
  },
  {
    path: '/default',
    name: 'Default',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "Default" */ '@/views/Default.vue')
  },
  {
    path: '/home',
    name: 'Home',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "Login" */ '@/views/Home.vue')
  },
  {
    path: '/inventory',
    name: 'Inventory',
    props: route => ({ billNo: route.query.billNo, tag: route.query.tag, invCheckWay: route.query.invCheckWay }),
    component: () => import(/* webpackChunkName: "Inventory" */ '@/views/invWare/invCheck/Inventory.vue')
  },
  // 库存报损新
  {
    path: '/invCheckDamage',
    name: 'invCheckDamage',
    props: route => ({ billNo: route.query.billNo, tag: route.query.tag }),
    component: () => import(/* webpackChunkName: "Inventory" */ '@/views/invWare/invCheck/damage.vue')
  },
  {
    path: '/orderOccupy',
    name: 'OrderOccupy',
    props: route => ({ warehouseID: route.query.warehouseID, warehouseName: route.query.warehouseName, itemID: route.query.itemID, itemName: route.query.itemName }),
    component: () => import(/* webpackChunkName: "OrderOccupy" */ '@/views/invWare/invCheck/OrderOccupy.vue')
  },
  // 整库盘点新
  {
    path: '/invCheckEntire',
    name: 'invCheckEntire',
    props: route => ({ billNo: route.query.billNo, tag: route.query.tag }),
    component: () => import(/* webpackChunkName: "Inventory" */ '@/views/invWare/invCheck/entire.vue')
  },
  // 部分盘点新
  {
    path: '/invCheckPart',
    name: 'invCheckPart',
    props: route => ({ billNo: route.query.billNo, tag: route.query.tag }),
    component: () => import(/* webpackChunkName: "Inventory" */ '@/views/invWare/invCheck/part.vue')
  },
  {
    path: '/messageCenter',
    name: 'MessageCenter',
    component: () => import(/* webpackChunkName: "MessageCenter" */ '@/views/infoCenter/MessageCenter.vue')
  },
  {
    path: '/inventoryQuery',
    name: 'InventoryQuery',
    props: route => ({ tag: route.query.tag }),
    component: () => import(/* webpackChunkName: "InventoryQuery" */ '@/views/invWare/invItem/InventoryQuery.vue')
  },
  {
    path: '/invChange',
    name: 'InvChange',
    component: () => import(/* webpackChunkName: "InvChange" */ '@/views/invWare/invItem/invChange.vue')
  },
  {
    path: '/vehicleDefine',
    name: 'VehicleDefine',
    component: () => import(/* webpackChunkName: "VehicleDefine" */ '@/views/security/VehicleDefine.vue')
  },
  // 收欠款
  {
    path: '/customerArrearPerOrder',
    name: 'CustomerArrearPerOrder',
    props: route => ({ customerID: route.query.customerID, customerName: route.query.customerName, financialBrandID: route.query.financialBrandID, financialBrandName: route.query.financialBrandName }),
    component: () => import(/* webpackChunkName: "CustomerArrearPerOrder" */ '@/views/saleManage/salPay/CustomerArrearPerOrder.vue')
  },
  {
    path: '/invMakeQuery',
    name: 'InvMakeQuery',
    component: () => import(/* webpackChunkName: "InvMakeQuery" */ '@/views/invWare/invMake/InvMakeQuery.vue')
  },
  {
    path: '/invMakeSearch',
    name: 'InvMakeSearch',
    component: () => import(/* webpackChunkName: "InvMakeSearch" */ '@/views/invWare/invMake/InvMakeSearch.vue')
  }, 
  {
    path: '/invMakeChange',
    name: 'InvMakeChange',
    component: () => import(/* webpackChunkName: "InvMakeChange" */ '@/views/invWare/invMake/InvMakeChange.vue')
  },
  {
    path: '/payBalance',
    name: 'PayBalance',
    component: () => import(/* webpackChunkName: "PayBalance" */ '@/views/salPayBalance/PayBalance.vue')
  },
  {
    path: '/customIsLargess',
    name: 'CustomIsLargess',
    component: () => import(/* webpackChunkName: "CustomIsLargess" */ '@/views/security/CustomIsLargess.vue')
  },
  {
    path: '/customerAdjust',
    name: 'CustomerAdjust',
    component: () => import(/* webpackChunkName: "CustomerAdjust" */ '@/views/financial/accountAdjust/CustomerAdjust.vue')
  },
  {
    path: '/salPaySearch',
    name: 'SalPaySearch',
    component: () => import(/* webpackChunkName: "SalPaySearch" */ '@/views/financial/accountAdjust/SalPaySearch.vue')
  },
  {
    path: '/financialBrand',
    name: 'FinancialBrand',
    component: () => import(/* webpackChunkName: "FinancialBrand" */ '@/views/security/FinancialBrand.vue')
  },
  {
    path: '/saleCollectQuery',
    name: 'SaleCollectQuery',
    component: () => import(/* webpackChunkName: "SaleCollectQuery" */ '@/views/dataSearch/SaleCollectQuery.vue')
  },
  {
    path: '/salesRanking',
    name: 'SalesRanking',
    component: () => import(/* webpackChunkName: "SalesRanking" */ '@/views/saleManage/ranking/index.vue')
  },
  {
    path: '/saleAnalysis',
    name: 'SaleAnalysis',
    component: () => import(/* webpackChunkName: "SaleAnalysis" */ '@/views/saleManage/analysis/index.vue')
  },
  {
    path: '/print',
    name: 'Print',
    component: () => import(/* webpackChunkName: "Print" */ '@/views/setUp/Print.vue')
  },
  {
    path: '/appPrint',
    name: 'AppPrint',
    component: () => import(/* webpackChunkName: "AppPrint" */ '@/views/setUp/AppPrint.vue')
  },
  {
    path: '/oneTicketPass',
    name: 'OneTicketPass',
    props: route => ({ billNo: route.query.billNo }),
    component: () => import(/* webpackChunkName: "OneTicketPass" */ '@/views/printTemplate/OneTicketPass.vue')
  },
  {
    path: '/orderReport',
    name: 'OrderReport',
    component: () => import(/* webpackChunkName: "OrderReport" */ '@/views/saleManage/OrderReport.vue')
  },
  {
    path: '/picTypeDefine',
    name: 'PicTypeDefine',
    component: () => import(/* webpackChunkName: "PicTypeDefine" */ '@/views/security/PicTypeDefine.vue')
  },
  {
    path: '/priceManagement',
    name: 'PriceManagement',
    props: route => ({ itemName: route.query.itemName }),
    component: () => import(/* webpackChunkName: "priceManagement" */ '@/views/security/PriceManagement.vue')
  },
  {
    path: '/priceDefinition',
    name: 'PriceDefinition',
    component: () => import(/* webpackChunkName: "priceManagement" */ '@/views/security/PriceDefinition.vue')
  },
  {
    path: '/salesmanAndDeliverCollect',
    name: 'SalesmanAndDeliverCollect',
    component: () => import(/* webpackChunkName: "salesmanAndDeliverCollect" */ '@/views/dataSearch/SalesmanAndDeliverCollect.vue')
  },
  {
    path: '/customerGoodsFeeForm',
    name: 'CustomerGoodsFeeForm',
    component: () => import(/* webpackChunkName: "CustomerGoodsFeeForm" */ '@/views/financial/feeBill/CustomerGoodsFeeForm.vue')
  },
  // 订货调整
  {
    path: '/salOrderItemChange',
    name: 'SalOrderItemChange',
    component: () => import(/* webpackChunkName: "SalOrderItemChange" */ '@/views/saleManage/salOrderMeet/SalOrderItemChange.vue')
  },
  {
    path: '/salOrderItemOrder',
    name: 'SalOrderItemOrder',
    props: route => ({ billNo: route.query.billNo, tag: route.query.tag }),
    component: () => import(/* webpackChunkName: "SalOrderItemOrder" */ '@/views/saleManage/salOrderMeet/SalOrderItemOrder.vue')
  },
  {
    path: '/salOrderItemDetail',
    name: 'SalOrderItemDetail',
    component: () => import(/* webpackChunkName: "SalOrderItemDetail" */ '@/views/saleManage/salOrderMeet/SalOrderItemDetail.vue')
  },
  {
    path: '/fileDownload',
    name: 'FileDownload',
    // props: route => ({ fileType: route.query.fileType }),
    component: () => import(/* webpackChunkName: "fileDownload" */ '@/components/common/fileDownload.vue')
  },
  {
    path: '/journal',
    name: 'Journal',
    component: () => import(/* webpackChunkName: "Journal" */ '@/views/security/Journal.vue')
  },
  {
    path: '/promotionDefine',
    name: 'PromotionDefine',
    component: () => import(/* webpackChunkName: "PromotionDefine" */ '@/views/security/PromotionDefine.vue')
  },
  {
    path: '/specialPrice',
    name: 'SpecialPrice',
    component: () => import(/* webpackChunkName: "SpecialPrice" */ '@/views/security/SpecialPrice.vue')
  },
  {
    path: '/feedback',
    name: 'Feedback',
    component: () => import(/* webpackChunkName: "Feedback" */ '@/views/monitorCenter/Feedback.vue')
  },
  {
    path: '/exchangeReport',
    name: 'ExchangeReport',
    component: () => import(/* webpackChunkName: "ExchangeReport" */ '@/views/dataSearch/ExchangeReport.vue')
  },
  {
    path: '/clearUpArrears',
    name: 'ClearUpArrears',
    component: () => import(/* webpackChunkName: "ClearUpArrears" */ '@/views/dataSearch/ClearUpArrears.vue')
  },
  {
    path: '/saleReportDimension',
    name: 'SaleReportDimension',
    props: route => ({ option: route.query.option}),
    component: () => import(/* webpackChunkName: "SaleReportDimension" */ '@/views/dataSearch/SaleReportDimension.vue')
  },
  // 销售数据统计报表耳机详情
  {
    path: '/commodityDetails',
    name: 'commodityDetails',
    props: route => ({ type: route.query.type, timestemp: route.query.timestemp }),
    component: () => import(/* webpackChunkName: "SaleReportDimension" */ '@/views/dataSearch/details/commodityDetails.vue')

  },
  {
    path: '/supplementIndex',
    name: 'SupplementIndex',
    component: () => import(/* webpackChunkName: "SupplementIndex" */ '@/views/supplement/index.vue')
  },
  // 库存主账
  {
    path: '/dataSearchStockMainAccount',
    name: 'DataSearchStockMainAccount',
    component: () => import(/* webpackChunkName: "dataSearchStockMainAccount" */ '@/views/dataSearch/stock/MainAccount.vue')
  },
  // 库存变动
  {
    path: '/dataSearchStockChange',
    name: 'DataSearchStockChange',
    component: () => import(/* webpackChunkName: "dataSearchStockChange" */ '@/views/dataSearch/stock/Change.vue')
  },
  // 库存流水
  {
    path: '/dataSearchStockTurnover',
    name: 'DataSearchStockTurnover',
    component: () => import(/* webpackChunkName: "dataSearchStockTurnover" */ '@/views/dataSearch/stock/Turnover.vue')
  },
  // 库存主账明细
  {
    path: '/dataSearchStockMainAccountDetailed',
    name: 'DataSearchStockMainAccountMainAccountDetailed',
    props: route => ({ options: Qs.parse(route.query) }),
    component: () => import(/* webpackChunkName: "dataSearchStockMainAccountDetailed" */ '@/views/dataSearch/stock/MainAccountDetailed.vue')
  },
  // 供应商对账
  {
    path: '/dataSearchSupplierReconciliation',
    name: 'DataSearchSupplierReconciliation',
    component: () => import(/* webpackChunkName: "dataSearchSupplierReconciliation" */ '@/views/dataSearch/supplier/Reconciliation.vue')
  },
  // 对账明细
  {
    path: '/dataSearchSupplierReconciliationDetailed',
    name: 'DataSearchSupplierReconciliationDetailed',
    props: route => ({ options: Qs.parse(route.query) }),
    component: () => import(/* webpackChunkName: "dataSearchSupplierReconciliationDetailed" */ '@/views/dataSearch/supplier/ReconciliationDetailed.vue')
  },
  // 客户对账
  {
    path: '/dataSearchCustomerReconciliation',
    name: 'DataSearchCustomerReconciliation',
    component: () => import(/* webpackChunkName: "dataSearchCustomerReconciliation" */ '@/views/dataSearch/customer/Reconciliation.vue')
  },
  // 客户对账明细
  {
    path: '/dataSearchReconciliationDetailed',
    name: 'DataSearchReconciliationDetailed',
    props: route => ({ options: Qs.parse(route.query) }),
    component: () => import(/* webpackChunkName: "dataSearchCustomerReconciliation" */ '@/views/dataSearch/customer/ReconciliationDetailed.vue')
  },
  // 订还货对账
  {
    path: '/dataSearchAdvanceOrderReconciliation',
    name: 'DataSearchAdvanceOrderReconciliation',
    component: () => import(/* webpackChunkName: "dataSearchAdvanceOrderReconciliation" */ '@/views/dataSearch/advance/OrderReconciliation.vue')
  },
  // 订还货流水
  {
    path: '/dataSearchOrderReconciliationTurnover',
    name: 'DataSearchOrderReconciliationTurnover',
    props: route => ({ options: Qs.parse(route.query), type: route.query.type, timestemp: route.query.timestemp }),
    component: () => import(/* webpackChunkName: "dataSearchOrderReconciliationTurnover" */ '@/views/dataSearch/advance/OrderReconciliationTurnover.vue')
  },
  // 订货余货查询
  {
    path: '/dataSearchOrderOrderReconciliationSurplus',
    name: 'DataSearchOrderOrderReconciliationSurplus',
    component: () => import(/* webpackChunkName: "dataSearchOrderOrderReconciliationSurplus" */ '@/views/dataSearch/advance/OrderReconciliationSurplus.vue')
  },
  // 承包数据查询
  {
    path: '/dataSearchContractDealer',
    name: 'DataSearchContractDealer',
    component: () => import(/* webpackChunkName: "dataSearchContractDealer" */ '@/views/dataSearch/contract/ContractDealer.vue')
  },
  // 承包业务数据查询
  {
    path: '/dataSearchContractWork',
    name: 'DataSearchContractWork',
    component: () => import(/* webpackChunkName: "dataSearchContractWork" */ '@/views/dataSearch/contract/ContractWork.vue')
  },
  //铺市
  {
    path: '/salemanMarket',
    name: 'SalemanMarket',
    component: () => import(/* webpackChunkName: "salemanMarket" */ '@/views/shopMarket/SalemanMarket.vue')
  },
  {
    path: '/customerCover',
    name: 'CustomerCover',
    props: route => ({ customerIDType: route.query.customerIDType, beginDate: route.query.beginDate, endDate: route.query.endDate }),
    component: () => import(/* webpackChunkName: "salemanMarket" */ '@/views/shopMarket/CustomerCover.vue')
  },
  {
    path: '/itemMarket',
    name: 'ItemMarket',
    props: route => ({ selectType: route.query.selectType, beginDate: route.query.beginDate, endDate: route.query.endDate }),
    component: () => import(/* webpackChunkName: "salemanMarket" */ '@/views/shopMarket/ItemMarket.vue')
  },
  {
    path: '/marketIndex',
    name: 'MarketIndex',
    component: () => import(/* webpackChunkName: "salemanMarket" */ '@/views/shopMarket/MarketIndex.vue')
  },
  // 监控中心
  // 用户定义
  {
    path: '/aftermarketUserDefine',
    name: 'AftermarketUserDefine',
    component: () => import(/* webpackChunkName: "salemanMarket" */ '@/views/monitorCenter/aftermarke/UserDefine.vue')
  },
  // 企业定义
  {
    path: '/aftermarketMonitorCenterEnterDefine',
    name: 'AftermarketMonitorCenterEnterDefine',
    component: () => import(/* webpackChunkName: "salemanMarket" */ '@/views/monitorCenter/aftermarke/MonitorCenterEnterDefine.vue')
  },
  // 意向客户
  {
    path: '/aftermarketIntentionDefine',
    name: 'AftermarketIntentionDefine',
    component: () => import(/* webpackChunkName: "salemanMarket" */ '@/views/monitorCenter/aftermarke/IntentionDefine.vue')
  },
  // 备注
  {
    path: '/remarks',
    name: 'remarks',
    component: () => import(/* webpackChunkName: "salemanMarket" */ '@/views/remarks/index.vue')
  },
  // crm海报管理
  {
    path: '/posterManagement',
    name: 'PosterManagement',
    component: () => import(/* webpackChunkName: "salemanMarket" */ '@/views/monitorCenter/aftermarke/PosterManagement.vue')
  },  // crm直播预告管理
  {
    path: '/liveManagement',
    name: 'LiveManagement',
    component: () => import(/* webpackChunkName: "salemanMarket" */ '@/views/monitorCenter/aftermarke/LiveManagement.vue')
  },
  // crm视频管理
  {
    path: '/videoManagement',
    name: 'VideoManagement',
    component: () => import(/* webpackChunkName: "salemanMarket" */ '@/views/monitorCenter/aftermarke/VideoManagement.vue')
  },
  // crm视频管理
  {
    path: '/carouselManagement',
    name: 'carouselManagement',
    component: () => import(/* webpackChunkName: "salemanMarket" */ '@/views/monitorCenter/aftermarke/carouselManagement.vue')
  },
  // 广告管理
  {
    path: '/adManagement',
    name: 'adManagement',
    component: () => import(/* webpackChunkName: "salemanMarket" */ '@/views/monitorCenter/aftermarke/adManagement.vue')
  },
  // 云丝商学院
  {
    path: '/yunsischool',
    name: 'yunsischool',
    component: () => import(/* webpackChunkName: "salemanMarket" */ '@/views/help/yunsischool.vue')
  },
  {
    path: '/yunsischoolDetail',
    name: 'yunsischoolDetail',
    props: route => ({ column: route.query.column, title: route.query.title }),
    component: () => import(/* webpackChunkName: "salemanMarket" */ '@/views/help/yunsischoolDetail.vue')
  }
]

const router = new VueRouter({
  // mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
